<template>
    <div class="my_treat_page">
        <div class="name_info">
            <div class="name_num">
                <span class="left"><label v-if="detailinfo.rankicon">{{ detailinfo.rankicon }}</label>{{detailinfo.name}}</span>
<!--                <span class="right" v-if="detailinfo.appointmentnum">{{detailinfo.appointmentnum}}</span>-->
            </div>
            <div class="account_info">
                <div class="sex_age_phone">
                    <span>{{detailinfo.sex}} . {{detailinfo.age}}</span>
                    <span v-if="detailinfo.phone">{{detailinfo.phone}}</span>
                </div>
                <div class="account">
                    <span>工号：{{dispname}}</span>
                </div>
            </div>

        </div>
        <div class="main_info">
            <div class="info_line">
              <span>预约时间</span>
              <p>{{detailinfo.appointmenttime}}</p>
            </div>
            <div class="info_line">
              <span>理疗名称</span>
              <p :class="'status'+detailinfo.execstatuscode">{{detailinfo.projectname}}，{{detailinfo.execstatusname}}</p>
            </div>
            <div class="info_line">
              <span>执行人</span>
              <div class="exec_doctor_list">
                <div class="doctor-item" v-for="(doctor, index) in detailinfo.doctorlist" :key="index">
                  <div>
                    <span v-if="doctor.ismain == 1" class="main-tag">主</span>
                    {{ doctor.dispname }}
                    <span class="point-text" v-if="doctor.pointlist && doctor.pointlist.length">
                       ({{ doctor.pointlist.join(',') }})
                    </span>
                  </div>
                  <div class="doctor-right" :class="getStatusClass(doctor)" @click="handleDoctorClick(doctor, detailinfo)">
                    <div class="time">
                      {{ formatTime(doctor, detailinfo) }}
                    </div>
                    <div class="status-text">
                      {{ formatStatus(doctor) }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="info_line">
              <span>执行床位</span>
              <p>{{detailinfo.roomname}}</p>
            </div>
            <div class="info_line">
              <span>签名时间</span>
              <p v-if="detailinfo.signaturetime">{{detailinfo.signaturetime || '--'}}</p>
              <div v-else style="color: #FA6400;display: flex;justify-content: flex-end;">
                <p>未签名</p>
                <a style="color: #2d8cf0;width: 60px;"  @click="changeRouter">  去签名</a>
              </div>
            </div>
            <div class="info_line">
              <span>配穴方案</span>
              <div>{{detailinfo.acupointdesc || '--'}}</div>
            </div>
            <div class="fold-wrap" :class="{ open: showMoreInfo }">
              <div class="info_line">
                <span>开单诊所</span>
                <p>{{detailinfo.clinicname || '--'}}</p>
              </div>

              <div class="info_line">
                <span>开单医生</span>
                <p>{{detailinfo.doctor || '--'}}</p>
              </div>

              <div class="info_line">
                <span>医生备注</span>
                <p>{{detailinfo.doctorremark || '--'}}</p>
              </div>

              <div class="info_line">
                <span>执行诊所</span>
                <p>{{detailinfo.execclinicname}}</p>
              </div>

              <div class="info_line">
                <span>执行时间</span>
                <p>{{detailinfo.exectime}}</p>
              </div>

              <div class="info_line" v-if="detailinfo.userid !== detailinfo.useuserid || detailinfo.customerid !== detailinfo.usecustomerid">
                <span>扣费账号</span>
                <p class="status2">{{detailinfo.feeaccount}}</p>
              </div>

              <div class="info_line">
                <span>签名图片</span>
                <p v-if="detailinfo.signaturetime" style="display:flex;justify-content:flex-end;">
                  <img :src="minimg" @click="showImage(detailinfo.signatureimg)">
                </p>
                <p v-else>--</p>
              </div>

              <div class="info_line treat-remark-line">
                <span>治疗备注</span>
                <div v-if="!isEditTreatRemark" class="treat-remark-wrap">
                  <p class="treat-remark-text">{{detailinfo.treatremark || '--'}}</p>
                  <button class="treat-remark-edit-btn" @click="openTreatRemarkEdit">修改</button>
                </div>
                <div v-else class="treat-remark-edit-wrap">
                  <van-field
                      class="treat-remark-field"
                      v-model="editTreatRemark"
                      type="textarea"
                      rows="3"
                      maxlength="500"
                      placeholder="请输入理疗备注"
                      show-word-limit
                  />
                  <div class="treat-remark-actions">
                    <button class="treat-remark-save-btn" :disabled="savingTreatRemark" @click="saveTreatRemark">保存</button>
                    <button class="treat-remark-cancel-btn" :disabled="savingTreatRemark" @click="cancelTreatRemarkEdit">取消</button>
                  </div>
                </div>
              </div>

            </div>
            <!-- 折叠区域结束 -->

            <!-- 按钮 -->
            <div class="toggle_btn" @click="showMoreInfo = !showMoreInfo">
              {{ showMoreInfo ? '收起' : '查看更多' }}
            </div>
        </div>

        <div class="exec_list" v-if="execlist.length > 0">
            <div class="exec_th">
                <span style="width: auto">理疗名称</span>
                <span style="width: auto">执行人</span>
                <span style="width: auto">执行状态</span>
<!--                <span>操作</span>-->
            </div>
            <div class="one" v-for="item in execlist" :key="item.id">
              <div class="exec_td">
                <span class="col-project">
                    {{item.projectname}}
                </span>

                <span class="col-doctor">
                    {{ item.execdoctorname }}
                    <template v-if="item.execdoctorname">
                        {{ item.isown == '1' ? '(本人)' : '(他人)' }}
                    </template>
                </span>

                <span
                  class="col-status"
                  style="color: #333"
                >
                    {{item.execstatusname}}
                </span>
              </div>
            </div>
        </div>

        <div class="btn_detail_info">
          <div class="btn_div" @click="medical">
            <i class="icon iconfont iconbingli"></i>
            <p>患者病历</p>
          </div>
          <div class="btn_div" @click="treat">
            <i class="icon iconfont iconyoujian"></i>
            <p>理疗记录</p>
          </div>
          <div class="btn_div" @click="check">
            <i class="icon iconfont iconshijian"></i>
            <p>检查历史</p>
          </div>
        </div>

         <div class="ctrl_bottom" v-if="show">
             <button @click="back">返回</button>
             <button @click="cancelProject" v-if="detailinfo.execstatuscode === '2' || detailinfo.execstatuscode === '3'">取消执行</button>
             <button class="exec_class" @click="openAcupointDialog(detailinfo)" v-if="detailinfo.execstatuscode === '2' || detailinfo.execstatuscode === '3' || detailinfo.execstatuscode === '4'" >配穴方案</button>
        </div>

        <van-dialog v-model="showimg" >
            <img :src="detailinfo.signatureimg"  style="object-fit: contain;height: auto;width: 100%;padding: 20px;"/>
        </van-dialog>

        <acupoint-allocation
            :visible.sync="showAcupointDialog"
            :qryType="2"
            :uname="uname"
            :usex="usex"
            :uage="uage"
            :uphone="uphone"
            :serviceId="serviceid"
            :userId="Number(detailinfo.useuserid)"
            :customerId="Number(detailinfo.usecustomerid)"
            :tCode="tcode"
            :qrydate="$route.query.qrydate || ''"
            :currentallpoints="currentAllPoints"
            :currentAcupointData="currentAcupointData"
            @save="handleAcupointSave"
        />

    </div>
</template>

<script>
import {wxtreatdetail, wxtreatopr, wxsavetreatremark, waitsignaturelist, wxoprtreat} from '@/api/medical'
    import { mapGetters } from 'vuex'
    import { Toast ,Dialog} from 'vant'
import { getServerNow } from '@/utils/time'
import AcupointAllocation from "@/view/acupointAllocation/index.vue";
    export default {
      components: {AcupointAllocation},
        computed: {
            ...mapGetters([
                'username','dispname','clinicid','isrefresh'
            ]),
        },
        data() {
            return {
                execstatus: '0',
                serviceid: '',
                doctor:'',
                roomid:'',
                doctorname: '',
                detailinfo: {},
                execlist:[],
                userid: '',
                customerid:'',
                tcode:'',
                name:'',
                sex:'',
                age:'',
                phone:'',
                show: true,
                showimg:false,
                minimg:'',
                signaturelist:[],

                showMoreInfo:false,
                timer: null,
                editTreatRemark: '',
                isEditTreatRemark: false,
                savingTreatRemark: false,

                showAcupointDialog:false,
                uname:null,
                usex:null,
                uphone:null,
                uage:null,
                currentAllPoints:null,
                currentAcupointData:[]
            }
        },
        mounted () {
            this.$store.dispatch('hideOrShowNav', false)

            this.getDetailInfo()
            this.startTimer()
        },
        created(){
            this.serviceid = this.$route.query.serviceid || '';
            this.searchList()
        },
        activated(){
          let refresh = sessionStorage.getItem("SIGN_REFRESH");

          if (refresh === "1") {
            sessionStorage.removeItem("SIGN_REFRESH");
            this.getDetailInfo()
          }
        },
        methods: {
            // 获取订单信息
            getDetailInfo(){
                Toast.loading({
                    message: '加载中...',
                    forbidClick: true,
                })
                let data = {
                    username: this.username,
                    serviceid: this.serviceid,
                    clinicid:this.clinicid
                }
                wxtreatdetail(data).then(response => {
                    Toast.clear()
                    if(response.response_body.signatureimg){

                        this.resizeImage(response.response_body.signatureimg)
                     }
                    this.detailinfo = response.response_body
                    this.execlist = response.response_body.execlist || []
                    this.execstatus = response.response_body.execstatuscode
                    this.doctor = response.response_body.execdoctorcode
                    this.roomid = response.response_body.roomid
                    this.doctorname = response.response_body.execdoctorname
                    this.name = response.response_body.name
                    this.sex = response.response_body.sex
                    this.age = response.response_body.age
                    this.phone = response.response_body.phone
                    this.userid = response.response_body.userid
                    this.customerid = response.response_body.customerid
                    this.tcode = response.response_body.projectcode

                })
            },
            //返回
            back() {
                if (window.history.length <= 1) {
                    this.$router.push({path:'/'});
                    return false
                } else {
                    this.$router.go(-1);
                }
                // this.$router.go(-1)
            },
            // 取消执行
            cancelProject(){
                this.$dialog.confirm({
                    title: null,
                    message: '确认取消本次分诊操作？',
                })
                .then(() => {
                    let data = {
                        username: this.username,
                        oprtype: '0',
                        serviceid: this.serviceid
                    }
                    wxtreatopr(data).then(() => {
                        this.$store.dispatch('changeIsRefresh', '1')
                        Toast.success('已成功取消本次分诊!');
                        this.show = false
                        let second = 2;
                        const timer = setInterval(() => {
                            second--;
                            if (second === 0) {
                                clearInterval(timer);
                                this.$router.go(-1)
                            }
                        }, 1000);

                    })
                })
                .catch(() => {
                    // on cancel
                });
            },
            medical() {
                this.$store.dispatch('changeIsRefresh', '1')
                this.$router.push({
                    path: '/medicalPage',
                    query: {
                        userid: this.detailinfo.useuserid,
                        customerid: this.detailinfo.usecustomerid,
                    }
                })
            },
            treat() {
                this.$store.dispatch('changeIsRefresh', '1')
                this.$router.push({
                    path: '/historyPage',
                    query: {
                        userid: this.detailinfo.useuserid,
                        customerid: this.detailinfo.usecustomerid,
                        name: this.name,
                        sex: this.sex,
                        age: this.age,
                        phone: this.phone
                    }
                })
            },
            check() {
                this.$store.dispatch('changeIsRefresh', '1')
                this.$router.push({
                    path: '/checkPage',
                    query: {
                        userid:  this.detailinfo.useuserid,
                        customerid: this.detailinfo.usecustomerid,
                        name: this.name,
                        sex: this.sex,
                        age: this.age,
                        phone: this.phone
                    }
                })
            },
            match(id, execstatus, acupointids) {
                this.$router.push({
                    path: '/matchAcupoint',
                    query: {
                        serviceid: id,
                        userid: this.userid,
                        customerid: this.customerid,
                        name: this.name,
                        sex: this.sex,
                        age: this.age,
                        phone: this.phone,
                        execstatus: execstatus,
                        acupointids: acupointids,
                    }
                })
            },
            // 待签名服务查询  waitsignaturelist
            // 查询待签名列表
            searchList(){
                let value = {
                    username: this.username,
                    serviceid: this.serviceid,
                };
                waitsignaturelist(value).then(res =>{

                    this.signaturelist = res.response_body.list
                })
            },
            changeRouter(){
                var arr = [...this.signaturelist]

                let datas = arr.filter(item => item.id != this.detailinfo.serviceid).map(item => item.projectname )

                if(datas.length > 0){

                    Dialog.confirm({
                        title: '提示',
                        message: `患者当天还存在其他理疗项目（${datas.join('、')}）未签名，是否同步签名`,
                        confirmButtonText:'全部签名',
                        cancelButtonText:'仅签名当前项目',
                    })
                    .then(() => {
                        // on confirm
                        this.$router.push({
                            path:'/signature',
                            query:{
                                serviceid:this.serviceid ,
                                isAll:'true',
                            }
                        })
                    })
                    .catch(() => {
                        // on cancel
                        this.$router.push({
                            path:'/signature',
                            query:{
                                serviceid:this.serviceid ,
                                isAll:'false',
                            }
                        })
                    });
                }else{
                    this.$router.push({
                        path:'/signature',
                        query:{
                            serviceid:this.serviceid ,
                            isAll:'false',
                        }
                    })
                }


            },
            showImage(){
                this.showimg = true
            },
            resizeImage(base64String) {
                let maxWidth = 100
                let maxHeight = 40
                const canvas = document.createElement("canvas");
                const context = canvas.getContext("2d");

                const img = new Image();
                // img.crossOrigin= 'anonymous'
                img.src = base64String ;
                let that = this
                img.onload = function() {

                        let scaleFactor = 1; // 初始化缩放因子为1（不缩放）

                        if (img.width > maxWidth || img.height > maxHeight) {
                            // 计算缩放因子
                            scaleFactor = Math.min((maxWidth / img.width), (maxHeight / img.height));

                            // 重新设定canvas的宽高
                            canvas.width = img.width * scaleFactor;
                            canvas.height = img.height * scaleFactor;
                        } else {
                            canvas.width = img.width;
                            canvas.height = img.height;
                        }

                    // 清空canvas内容
                    context.clearRect(0, 0, canvas.width, canvas.height);

                    // 绘制缩放后的图片
                    context.drawImage(img, 0, 0, canvas.width, canvas.height);

                    // 输出结果


                     that.minimg = canvas.toDataURL();
                    //  alert(this.minimg)
                    //  return minimg
                    };

            },

            // 状态文字
            formatStatus(doctor) {
              if (doctor.status == 0) return '开始治疗'
              if (doctor.status == 1) return '完成治疗'
              if (doctor.status == 2) return '已完成'
              return ''
            },

            // 时间显示
            formatTime(doctor) {
              if (doctor.status == 0) {
                return '--:--'
              }

              let seconds = 0

              // 已完成
              if (doctor.status == 2) {
                seconds = this.getSeconds(doctor.endtime) - this.getSeconds(doctor.starttime)
              }

              // 执行中（动态）
              if (doctor.status == 1) {
                seconds = Math.floor(getServerNow() / 1000) - this.getSeconds(doctor.starttime)
              }

              if (seconds < 0) seconds = 0

              const m = Math.floor(seconds / 60)
              const s = seconds % 60

              return `${this.pad(m)}:${this.pad(s)}`
            },

            // 时间转秒（兼容字符串）
            getSeconds(time) {
              if (!time) return 0

              const safeTime = time.replace(/-/g, '/')
              const timestamp = new Date(safeTime).getTime()
              if (isNaN(timestamp)) return 0

              return Math.floor(timestamp / 1000)
            },

            pad(num) {
              return num < 10 ? '0' + num : num
            },

            startTimer() {
              this.timer = setInterval(() => {
                // 触发视图更新（关键）
                this.$forceUpdate()
              }, 1000)
            },

            getStatusClass(doctor) {
              if (doctor.status == 2) return 'status-finished'
              return 'status-active'
            },

            handleDoctorClick(doctor, item) {
              // 已完成不允许再点
              if (doctor.status == 2) return

              let oprtype = null
              let text = ''

              if (doctor.status == 0) {
                oprtype = 1
                text = '确认开始治疗？'
              }

              if (doctor.status == 1) {
                oprtype = 2
                text = '确认结束治疗？'
              }

              // 二次确认
              Dialog.confirm({
                title: '提示',
                message: text,
                confirmButtonText: '确认',
                cancelButtonText: '取消'
              })
                  .then(() => {
                    // 点击确认才执行接口
                    wxoprtreat({
                      serviceId: item.serviceid,
                      treatId: doctor.treatid,
                      oprType: oprtype,
                      doctor: this.username
                    }).then((response) => {
                      if (response.response_body.flag) {
                        Toast.success('操作成功')

                        // 更新状态
                        doctor.status = oprtype

                        // 使用接口返回时间
                        if (oprtype == 1) {
                          doctor.starttime = response.response_body.startTime
                        }

                        if (oprtype == 2) {
                          doctor.endtime = response.response_body.endTime
                          this.getDetailInfo()
                        }
                      }else{
                        if (!response.response_body.issign){
                          Dialog.confirm({
                            title: '提示',
                            message: response.response_body.msg,
                            confirmButtonText: '去签名',
                            cancelButtonText: '取消'
                          })
                              .then(() => {
                                this.changeRouter()
                              })
                              .catch(() => {
                                // 点击取消，不做任何事
                              })
                        }else{
                          Toast.fail(response.response_body.msg)

                          setTimeout(() => {
                            this.getDetailInfo()
                          }, 1000)
                        }
                      }
                    })
                  })
                  .catch(() => {
                    // 点击取消，不做任何事
                  })
            },

            //分工配穴
            openAcupointDialog(item){
              //detailinfo
              this.uname = item.name
              this.uphone = item.phone
              this.usex = item.sex
              this.uage = item.age
              this.currentAllPoints = item.acupointdesc
              this.currentAcupointData = item.doctorlist
              this.showAcupointDialog = true
            },
            handleAcupointSave() {
              // 刷新页面
              this.getDetailInfo()
            },
            // 打开理疗备注编辑框，并回填当前备注内容
            openTreatRemarkEdit() {
              this.editTreatRemark = this.detailinfo.treatremark || ''
              this.isEditTreatRemark = true
            },
            // 取消编辑理疗备注，恢复为展示状态
            cancelTreatRemarkEdit() {
              this.editTreatRemark = ''
              this.isEditTreatRemark = false
            },
            // 保存理疗备注，提交当前服务和登录医生信息
            saveTreatRemark() {
              this.savingTreatRemark = true
              Toast.loading({
                message: '保存中...',
                forbidClick: true,
              })
              const data = {
                serviceid: this.serviceid,
                remark: this.editTreatRemark,
                doctor: this.username
              }
              // 调用接口保存当前理疗备注
              wxsavetreatremark(data).then(response => {
                Toast.clear()
                this.savingTreatRemark = false
                if (response.response_body.flag) {
                  Toast.success('修改成功')
                  this.detailinfo.treatremark = this.editTreatRemark
                  this.cancelTreatRemarkEdit()
                } else {
                  Toast.fail(response.response_body.errorMsg || response.response_body.msg || '修改失败')
                }
              }).catch(() => {
                Toast.clear()
                this.savingTreatRemark = false
                Toast.fail('修改失败')
              })
            },
        },
    }
</script>

<style lang="scss" scoped>
.fold-wrap {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.35s ease;
}

/* 展开 */
.fold-wrap.open {
  max-height: 1200px; /* 足够大即可 */
}

/* 按钮样式 */
.toggle_btn {
  text-align: center;
  color: #2d8cf0;
  padding: 10px 0;
  font-size: 14px;
}

.my_treat_page .main_info .info_line .exec_doctor_list .doctor-item {
  margin: 5px 0;
  line-height: 20px;
  text-align: right;   /* 保持你原来右对齐风格 */
  width: auto;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
}

.doctor-right {
  text-align: center !important;
  border-radius: 8px;
  padding: 5px 10px;
  width: auto !important;
}

/* 已完成：灰底灰字 */
.my_treat_page .main_info .info_line .exec_doctor_list .status-finished {
  background: #f2f2f2;
  color: #999;
}

/* 未开始 + 执行中：土黄底白字 */
.my_treat_page .main_info .info_line .exec_doctor_list .status-active {
  background: #CF8C57;
  color: #fff;
}

/* 时间 */
.my_treat_page .main_info .info_line .exec_doctor_list .time {
  font-size: 14px;
  width: auto !important;
  text-align: center;
}

/* 状态文字 */
.my_treat_page .main_info .info_line .exec_doctor_list .status-text {
  font-size: 12px;
  margin-top: 2px;
  width: auto !important;
}

.main-tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 0.53333rem !important;
  height: 0.53333rem;
  background: #CF8C57;
  color: #fff !important;
  border-radius: 50%;
  font-size: 0.32rem;
  margin-right: 0.16rem;
  flex-shrink: 0;
  padding: 0 !important;
}

.exec_td{
  display:flex;
  align-items:center;
}

.col-project{
  flex:1;
  text-align:center;
}

.col-doctor{
  flex:1;
  text-align:center;

  /* 名字太长省略 */
  overflow:hidden;
  white-space:nowrap;
  text-overflow:ellipsis;
}

.col-status{
  flex:1;
  text-align:center;
}

.treat-remark-line .treat-remark-wrap {
  width: calc(100% - 80px);
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  gap: 8px;
}

.treat-remark-line .treat-remark-text {
  flex: 1;
  width: auto !important;
  text-align: right;
  white-space: pre-wrap !important;
  word-break: break-all;
  overflow: visible !important;
  text-overflow: clip !important;
  display: block !important;
  -webkit-line-clamp: unset !important;
  -webkit-box-orient: unset !important;
}

.treat-remark-line .treat-remark-edit-btn {
  flex-shrink: 0;
  border: none;
  background: transparent;
  color: #2d8cf0;
  font-size: 12px;
  padding: 0;
}

.treat-remark-line .treat-remark-edit-wrap {
  width: calc(100% - 80px) !important;
  text-align: left !important;
}

.treat-remark-line .treat-remark-field {
  width: 100% !important;
}

.treat-remark-line .treat-remark-edit-wrap .van-cell,
.treat-remark-line .treat-remark-field {
  box-sizing: border-box;
  padding: 6px 8px;
  border: 1px solid #ebedf0;
  border-radius: 4px;
}

.treat-remark-line .treat-remark-edit-wrap /deep/ .van-field__control {
  width: 100% !important;
  height: 72px !important;
  min-height: 72px !important;
  max-height: 72px !important;
  overflow-y: auto;
  text-align: left;
}

.treat-remark-line .treat-remark-edit-wrap /deep/ .van-cell__value,
.treat-remark-line .treat-remark-edit-wrap /deep/ .van-field__value,
.treat-remark-line .treat-remark-edit-wrap /deep/ .van-field__body,
.treat-remark-line .treat-remark-edit-wrap /deep/ .van-field__word-limit {
  width: 100% !important;
}

.treat-remark-line .treat-remark-edit-wrap /deep/ .van-field__word-limit {
  text-align: right !important;
}

.treat-remark-line .treat-remark-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 8px;
  width: 100% !important;
}

.treat-remark-line .treat-remark-save-btn,
.treat-remark-line .treat-remark-cancel-btn {
  min-width: 48px;
  height: 28px;
  border-radius: 4px;
  font-size: 12px;
}

.treat-remark-line .treat-remark-save-btn {
  border: none;
  color: #fff;
  background: #2d8cf0;
}

.treat-remark-line .treat-remark-cancel-btn {
  color: #666;
  background: #fff;
  border: 1px solid #dcdee2;
}
</style>
